import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { DatePipe } from '@angular/common';
import { SocketService } from 'app/shared/common/helper/socket.service';
import { Configuration } from 'app/app.configuration';
import { DataService } from 'app/shared/common/helper/http-service';

@Injectable({
    providedIn: 'root',
})

export class CalendarService implements Resolve<any>
{
    userId = this.parseService.instance.User.current().id;
    projectArray: any;
    events: any;
    leaves: any;
    eventValues = [];
    onEventsUpdated: Subject<any>;
    empRole = '';
    profileId = '';
    currentuser: any;
    rejectedProjectId: any;
    projectArrayreq: any;
    userPermissionReqId: any;
    firstname = '';
    lastname = '';
    leaveDetails = new Subject<any>();
    tenantId = '';

    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        private parseService: ParseService,
        private toastr: ToastrService,
        public dialog: MatDialog,
        private queryInterface: QueryInterface,
        private storageConfiguration: StorageConfiguration,
        private hardCodedValues: HardCodedValues,
        private _socket: SocketService,
        private dataService: DataService,
        private configuration: Configuration
    ) {
        this.currentuser = this.parseService.instance.User.current();
        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
        this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
        this.profileId = this.currentuser.get('profile').id;
        this.firstname = this.parseService.instance.User.current().get('firstName');
        this.lastname = this.parseService.instance.User.current().get('lastName');
        this.onEventsUpdated = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     * 
     */
    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<any> | Promise<any> | any> {
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getEvents()]).then(
                    ([events]: [any]) => {
                        resolve();
                    },
                    reject
                );
        });
    }

    async returnEvents() {
        await this.setAllEvents();
        return this.events;
    }

    async setAllEvents(date?) {
        let eventArray = [];
        let classArray = [];
        let leave;
        let leaveQueryInstance = this.parseService.instance.Object.extend('Leaves');
        let leaveQuery = new this.parseService.instance.Query(leaveQueryInstance);
        leaveQuery.include('requesterId');
        leaveQuery.include('reporterId');
        leaveQuery.equalTo('tenantId', this.tenantId);
        leaveQuery.limit(100000);
        let startend = this.startenddates(date ? date : new Date());
        let firstDay = startend[0];
        let lastDay = startend[1];
        leaveQuery.greaterThan('startDate', firstDay);
        leaveQuery.lessThan('endDate', lastDay);

        if (this.empRole == 'Employee') {
            leaveQuery.equalTo('requesterId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
        }
        else if (this.empRole == 'Leader') {
            leaveQuery.equalTo('reporterId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
        }

        let leaderQueryInstance = this.parseService.instance.Object.extend('Leaves');
        let leaderQuery = new this.parseService.instance.Query(leaderQueryInstance);
        leaderQuery.limit(100000);
        leaderQuery.greaterThan('startDate', firstDay);
        leaderQuery.lessThan('endDate', lastDay);
        leaderQuery.equalTo('tenantId', this.tenantId);
        leaderQuery.equalTo('requesterId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });

        let holidayQueryInstance = this.parseService.instance.Object.extend('Holidays');
        let holidayQuery = new this.parseService.instance.Query(holidayQueryInstance);
        let actualDate = date ? date : new Date();
        let currentYear = actualDate.getFullYear();
        holidayQuery.equalTo('year', currentYear);
        holidayQuery.equalTo('tenantId', this.tenantId);
        let role = this.empRole;
        await Promise.all([leaveQuery.find(), leaderQuery.find(), holidayQuery.find()]).then(function ([leaves, leaderLeave, holidays]) {
            eventArray.push({ leaves: leaves, leaderLeave: leaderLeave, holidays: holidays });

            // todo.forEach(element => {
            //     element.get('assigneesId').forEach(innerElement => {
            //         if (innerElement == userId) {
            //             let assignees = [];
            //             let assigneesId = [];
            //             const getRelationsAssignee = async function (result) {
            //                 var reportingList = [];
            //                 await result
            //                     .query()
            //                     .each(function (obj) {
            //                         reportingList.push(obj);
            //                     });
            //                 return reportingList;
            //             }
            //             getRelationsAssignee(element.get('assignees')).then(assignee => {
            //                 assignee.forEach(assigneeElement => {
            //                     assignees.push({
            //                         id: assigneeElement.id,
            //                         name: assigneeElement.get('firstName') + ' ' + assigneeElement.get('lastName'),
            //                         image: assigneeElement.get('profileImageInfo').url == undefined ? hardCodeValue.defaultProfileImg : assigneeElement.get('profileImageInfo').url
            //                     });
            //                     assigneesId.push(assigneeElement.id)

            //                 });
            //             });
            //             if (!element.get('deleted')) {
            //                 let todoValue = {
            //                     start: element.get('taskDetails').startDate,
            //                     end: element.get('taskDetails').dueDate,
            //                     title: element.get('taskDetails').title,
            //                     notes: element.get('taskDetails').notes,
            //                     allDay: true,
            //                     color: element.get('completed') == true ? { primary: 'grey', secondary: 'grey' } : { primary: '#bb41f4', secondary: '#bb41f4' },
            //                     resizable: {
            //                         beforeStart: true,
            //                         afterEnd: true
            //                     },
            //                     meta: {
            //                         location: '',
            //                         notes: element.get('leaveType')
            //                     },
            //                     taskId: element.id,
            //                     assignees: assignees,
            //                     assigneesId: assigneesId,
            //                     comments: element.get('comments'),
            //                     completed: element.get('completed'),
            //                     owner: element.get('owner'),
            //                     important: element.get('important'),
            //                     starred: element.get('starred'),
            //                     tags: element.get('tags'),
            //                     rejectReason: element.get('rejectReason'),
            //                 }
            //                 classArray.push(todoValue);
            //             }
            //         }
            //     });
            // });

            if (role == 'Leader' || role == 'Admin') {
                leaderLeave.forEach(element => {
                    let leaveInfo;
                    let requester = element.get('requesterId');
                    leaveInfo = 'My Event :  ' + element.get('requestType') + ':  ' + element.get('leaveType') + ' - ' + '  ' + element.get('reason') + ' ' + ' Status :  ' + element.get('status');

                    leaderLeave = {
                        start: element.get('startDate'),
                        end: element.get('endDate'),
                        requestType: element.get('requestType'),
                        reason: element.get('reason'),
                        appliedDate: element.get('appliedDate'),
                        backToWorkDate: element.get('backToWorkDate'),
                        totalDays: element.get('totalDays'),
                        title: leaveInfo,
                        status: element.get('status'),
                        leaveType: element.get('leaveType'),
                        startTime: element.get('startTime'),
                        endTime: element.get('endTime'),
                        rejectReason: element.get('rejectReason'),
                        sessionType: element.get('sessionType') ? element.get('sessionType') : '',
                        allDay: true,
                        color: {
                            primary: '#006400',
                            secondary: '#006400'
                        },
                        resizable: {
                            beforeStart: true,
                            afterEnd: true
                        },
                        draggable: true,
                        meta: {
                            location: '',
                            notes: element.get('leaveType')
                        },
                        leaveId: element.id,
                        requesterId: requester.id,
                        reporterId: element.get('reporterId').id
                    };
                    classArray.push(leaderLeave);
                });
            }

            leaves.forEach(element => {
                let leaveInfo;
                let requester = element.get('requesterId');
                let requesterName = requester.get('username');

                if (role == 'Employee') {
                    leaveInfo = element.get('requestType') + ':  ' + element.get('leaveType') + ' - ' + '  ' + element.get('reason') + ' ' + ' Status :  ' + element.get('status');
                }
                else if (role == 'Leader' || role == 'Admin') {
                    leaveInfo = requesterName + ' ' + element.get('requestType') + ':  ' + element.get('leaveType') + ' - ' + '  ' + element.get('reason') + ' ' + ' Status :  ' + element.get('status');
                }

                leave = {
                    start: element.get('startDate'),
                    end: element.get('endDate'),
                    requestType: element.get('requestType'),
                    reason: element.get('reason'),
                    appliedDate: element.get('appliedDate'),
                    backToWorkDate: element.get('backToWorkDate'),
                    totalDays: element.get('totalDays'),
                    title: leaveInfo,
                    status: element.get('status'),
                    leaveType: element.get('leaveType'),
                    startTime: element.get('startTime'),
                    endTime: element.get('endTime'),
                    rejectReason: element.get('rejectReason'),
                    sessionType: element.get('sessionType') ? element.get('sessionType') : '',
                    allDay: true,
                    color: {
                        primary: '#F44336',
                        secondary: '#FFCDD2'
                    },
                    resizable: {
                        beforeStart: true,
                        afterEnd: true
                    },
                    draggable: true,
                    meta: {
                        location: '',
                        notes: element.get('leaveType')
                    },
                    leaveId: element.id,
                    requesterId: requester.id,
                    reporterId: element.get('reporterId').id
                };
                classArray.push(leave);
            });

            if (holidays.length > 0) {
                let holidayDetails = holidays[0].get('holidayDetails')
                holidayDetails.forEach(holidayItems => {
                    let holiday = {
                        start: holidayItems.date,
                        end: holidayItems.date,
                        color: {
                            primary: '#5F61A2',
                            secondary: '#A8F515'
                        },
                        meta: {
                            location: '',
                            notes: 'Holidays'
                        },
                        title: holidayItems.holidayName,
                        draggable: true,
                        resizable: {
                            beforeStart: true,
                            afterEnd: true
                        }
                    }
                    classArray.push(holiday);
                });
            }
        });
        this.eventValues = classArray;
        this.getLeaveData();
        return classArray;
    }

    getLeaveData(): Observable<any> {
        this.leaveDetails.next(this.eventValues);
        return this.leaveDetails.asObservable();
    }

    /**
     * Get events
     *
     * @returns {Promise<any>}
     */
    getEvents(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            await this.setAllEvents();
            this.events = this.eventValues;
            this.onEventsUpdated.next(this.events);
            resolve(this.events);
        });
    }

    /**
     * Update events
     *
     * @param events
     * @returns {Promise<any>}
     */

    updateEvents(events): Promise<any> {
        const eventIndex = localStorage.getItem('eventIndex');
        const event = events[eventIndex];
        return new Promise(async (resolve, reject) => {
            await this.queryInterface.executeQuery(this.parseService, 'Leaves', [
                { condition: 'equalTo', field: 'objectId', value: event.leaveId }]).then(result => {
                    let leave = result[0];
                    leave = this.LeaveForm(leave, event, '', 'Edit');
                    leave.save().then((leave) => {
                        this.getEvents();
                        this.toastr.success('Leave Updated!');
                    }, (error) => {
                        // this.toastr.error('Leave Update Failed');
                    });
                });
        });
    }

    async getProfileId(profileId) {
        let queryInstance = this.parseService.instance.Object.extend("User")
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo("profile", { __type: "Pointer", className: "Profile", objectId: profileId });
        let results = await query.find();
        return results[0].id;
    }

    addPermission(permissionData) {
        let leaveClass = this.parseService.instance.Object.extend('Leaves');
        var leaveDetails = new leaveClass();
        leaveDetails.set('startDate', (new Date(permissionData.data.startDate)));
        leaveDetails.set('endDate', (new Date(permissionData.data.endDate)));
        leaveDetails.set('backToWorkDate', (new Date(permissionData.data.endDate)));
        leaveDetails.set('startTime', (permissionData.data.startTime).toUpperCase());
        leaveDetails.set('endTime', (permissionData.data.endTime).toUpperCase());
        leaveDetails.set('reason', permissionData.data.reason);
        leaveDetails.set('status', 'Pending');
        leaveDetails.set('requestType', permissionData.eventType);
        leaveDetails.set('sessionType', permissionData.data.sessionType ? permissionData.data.sessionType : '');
        leaveDetails.set('appliedDate', (new Date(permissionData.data.appliedDate)));
        leaveDetails.set('totalDays', 0);
        leaveDetails.set('leaveType', '');
        leaveDetails.set('requesterId', { __type: 'Pointer', className: 'Profile', objectId: permissionData.profileId });
        leaveDetails.set('reporterId', { __type: 'Pointer', className: 'Profile', objectId: permissionData.reportingTo });
        leaveDetails.set('rejectReason', '');
        leaveDetails.set('tenantId', this.tenantId);
        leaveDetails.save().then(async res => {
            let userId = await this.getProfileId(res.get('requesterId').objectId);
            let assignedProject = await this.getCurrentProjects(userId);
            this.getEvents();
            let values = res;
            let profile = new this.parseService.instance.Object('Profile');
            profile.id = res.get('reporterId').objectId;

            let requester = new this.parseService.instance.Object('Profile');
            requester.id = res.get('requesterId').objectId;

            let datePipe = new DatePipe('en-US');
            let context = {
                name: profile.get('firstName') + ' ' + profile.get('lastName'),
                fromDate: datePipe.transform(values.get('startDate'), 'dd/MM/yyyy'),
                startTime: values.get('startTime'),
                endTime: values.get('endTime'),
                appliedDate: datePipe.transform(values.get('appliedDate'), 'dd/MM/yyyy'),
                reason: values.get('reason'),
                permissionStatus: values.get('status'),
                profileImage: requester.get('profileImageInfo').url,
                project: assignedProject,
                regardsName: requester.get('firstName') + ' ' + requester.get('lastName'),
                email: profile.get('email'),
            };
            let data = {
                context: context,
                toEmail: context.email
            }

            this.dataService.add(this.configuration.permissionRequest, data).subscribe((data: any) => {
            });

            let sendSocket = {
                event_type: 'PERMISSION_REQUEST',
                event_owner: {
                    id: this.parseService.instance.User.current().get('profile').id,
                    name: this.firstname + ' ' + this.lastname,
                },
                event_receiver: {
                    id: profile.id,
                    name: profile.get('firstName') + ' ' + profile.get('lastName'),
                },
                message: this.firstname + ' ' + this.lastname + ' applied for a permission.',
                event_created_Date: new Date(),
                initiated_source: 'web'
            }
            this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);

            this.toastr.success('Permission Applied Successfully.');

        }, (error) => {
        });
    }

    async permissionUpdate(permissionData, action) {
        await this.queryInterface.executeQuery(this.parseService, 'Leaves', [
            { condition: 'equalTo', field: 'objectId', value: permissionData.permissionId },
            { condition: 'include', value: 'requesterId' },
            { condition: 'include', value: 'reporterId' }]).then(result => {
                let leave = result[0];
                leave.set('startDate', (new Date(permissionData.data.startDate)));
                leave.set('endDate', (new Date(permissionData.data.endDate)));
                leave.set('startTime', (permissionData.data.startTime).toUpperCase());
                leave.set('endTime', (permissionData.data.endTime).toUpperCase());
                leave.set('reason', permissionData.data.reason);
                leave.set('sessionType', permissionData.data.sessionType ? permissionData.data.sessionType : '');
                leave.set('appliedDate', (new Date(permissionData.data.appliedDate)));
                leave.set('requestType', permissionData.eventType);
                leave.set('tenantId', this.tenantId);
                leave.set('rejectReason', permissionData.data.rejectReason);
                leave.set('status', action === 'edit' ? permissionData.data.status : 'Pending');
                leave.set('requesterId', { __type: 'Pointer', className: 'Profile', objectId: permissionData.requesterId });
                leave.save().then(async res => {
                    let status = res.get('status');
                    let requestType = res.get('requestType');
                    let values = res;

                    let profile = new this.parseService.instance.Object('Profile');
                    profile.id = res.get('requesterId').objectId;

                    let userId = await this.getProfileId(res.get('requesterId').objectId);
                    let assignedProject = await this.getCurrentProjects(userId);

                    let datePipe = new DatePipe('en-US');
                    let context = {
                        regardsName: profile.get('firstName') + ' ' + profile.get('lastName'),
                        fromDate: datePipe.transform(values.get('startDate'), 'dd/MM/yyyy'),
                        startTime: values.get('startTime'),
                        endTime: values.get('endTime'),
                        appliedDate: datePipe.transform(values.get('appliedDate'), 'dd/MM/yyyy'),
                        reason: values.get('reason'),
                        permissionStatus: values.get('status'),
                        profileImage: profile.get('profileImageInfo').url,
                        project: assignedProject,
                        name: res.get('reporterId').get('firstName') + ' ' + res.get('reporterId').get('lastName'),
                        email: profile.get('email')
                    };
                    let data = {
                        context: context,
                        toEmail: context.email
                    }

                    if (status === 'Approved' || status === 'Rejected') {
                        let sendSocket = {
                            event_type: 'PERMISSION_UPDATE',
                            event_owner: {
                                id: this.parseService.instance.User.current().get('profile').id,
                                name: this.firstname + ' ' + this.lastname,
                            },
                            event_receiver: {
                                id: profile.id,
                                name: profile.get('firstName') + ' ' + profile.get('lastName'),
                            },
                            message: status + ' your permission request',
                            event_created_Date: new Date(),
                            initiated_source: 'web'
                        }
                        this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);
                    }

                    if (status === 'Approved') {
                        this.toastr.success(requestType + " " + 'Approved !');
                        this.dataService.add(this.configuration.permissionApprove, data).subscribe((data: any) => {
                        });
                    }
                    else if (status === 'Rejected') {
                        this.toastr.error(requestType + " " + 'Rejected !');
                        this.dataService.add(this.configuration.permissionReject, data).subscribe((data: any) => {
                        });
                    }
                    else {
                        this.toastr.success('Permission Updated!');
                    }
                    this.getEvents();
                });
            });
    }

    async getCurrentProjects(userId) {
        let result = [];
        let assignedProject = '';
        let queryInstance = this.parseService.instance.Object.extend("ProjectMembers")
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo("isActive", true);
        query.include("project");
        query.include("project.client");
        query.equalTo("user", { __type: "Pointer", className: "_User", objectId: userId });
        query.equalTo("status", 'Assigned');
        let projectValues = await query.find();
        for (let i = 0; i < projectValues.length; i++) {
            let projectResults = JSON.parse(JSON.stringify(projectValues[i]));
            result.push(
                projectResults.project.projectInfo.projectName,
            );
        }
        return assignedProject = result.join(', ');
    }

    LeaveForm(leave, data, subData, type) {
        if (type !== 'Edit') {
            let startDate = new Date(data.startDate);
            let appliedDate = new Date(data.appliedDate);
            if (subData.eventTypeValue != 'Permission') {
                if (startDate >= appliedDate) {
                    subData.eventTypeValue = 'Pre-Leave';
                }
                else if (startDate < appliedDate) {
                    subData.eventTypeValue = 'Post-Leave';
                }
            }
        }
        leave.set('tenantId', this.tenantId)
        leave.set('startDate', (new Date(data.startDate)));
        leave.set('endDate', (new Date(data.endDate)));
        leave.set('startTime', '00:00');
        leave.set('endTime', '00:00');
        leave.set('sessionType', data.sessionType ? data.sessionType : '');
        leave.set('totalDays', data.totalDays);
        leave.set('reason', data.reason);
        leave.set('backToWorkDate', (new Date(data.backToWorkDate)));
        leave.set('appliedDate', (new Date(data.appliedDate)));
        leave.set('leaveType', data.leaveType);
        leave.set('rejectReason', data.rejectReason ? data.rejectReason : '');
        leave.set('status', type === 'Edit' ? data.status : 'Pending');
        leave.set('requestType', subData.eventTypeValue);
        if (type !== 'Edit') {
            leave.set('reporterId', { __type: 'Pointer', className: 'Profile', objectId: subData.reportingTo });
            leave.set('requesterId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
            leave.set('createdBy', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
        }
        else if (type == 'Edit') {
            leave.set('requesterId', leave.get('requesterId'));
        }
        return leave;
    }

    startenddates(day) {
        let getTot = this.daysInMonth(day.getMonth(), day.getFullYear(), day.getDate());
        let as = Math.round(getTot / 2);
        day.setDate(as);
        let startdate = this.daybefore(new Date(day));
        startdate.setHours(23, 59, 59, 999);

        let enddate = this.dayafter(day);
        enddate.setHours(0, 0, 0, 0);
        return [startdate, enddate];
    }

    startEndDates(day) {
        let startdate = this.dayBefore(new Date(day));
        startdate.setHours(23, 59, 59, 999);
        let enddate = this.dayAfter(day);
        enddate.setHours(0, 0, 0, 0);
        return [startdate, enddate];
    }

    dayafter(d) {
        let day = new Date(d);
        return new Date(day.getFullYear(), day.getMonth() + 2, 1);
    }

    daybefore(d) {
        let day = new Date(d);
        return new Date(day.getFullYear(), day.getMonth(), 0);
    }

    daysInMonth(month, year, date) {
        return new Date(year, month, date).getDate();
    }

    dayAfter(d) {
        let day = new Date(d);
        return new Date(day.setDate(day.getDate() + 1));
    }

    // previous day end date
    dayBefore(d) {
        let day = new Date(d);
        return new Date(day.setDate(day.getDate() - 1));
    }


}
